import { firestore as db } from "../firebase";

import { collection,doc, addDoc,getDocs,query, where, limit,orderBy, setDoc,deleteDoc,startAt,endBefore } from "firebase/firestore"; 


//Tranasactions Query

export const getTransaction = ({driver,date_from,date_to,party,vehicle})=> {  
    const filters = []
    if(driver) filters.push(where("driver", "==", driver))
    if(party) filters.push(where("party_name", "==", party))
    if(vehicle) filters.push(where("vehicle", "==", vehicle))
    if(date_from) filters.push(where("date", ">=", date_from))
    if(date_to) filters.push(where("date", "<=", date_to))

    const q = query(collection(db, "transactions"),orderBy('date'), ...filters )
    //const q = query(collection(db, "transactions") , where("driver", "==", driver) ,where("labour", "==", labour) )
    return getDocs(q)
 }
export const addTransaction = (data)=>{
    return addDoc(collection(db,'transactions'),data)
}
export const updateTransaction = (docid,data)=>{
    const updatedData = {...data}
    delete updatedData.docid
    return setDoc(doc(db,'transactions',docid),updatedData)
}
export const deleteTransaction  = (docid)=> deleteDoc(doc(db,'transactions',docid))


//driver Queries
export const getDrivers = ()=> getDocs(collection(db,'drivers'))
export  const addDriver  =  (data)=> addDoc(collection(db,'drivers'),data)
export  const updateDriver  =  (docid,data)=> {
    const updatedData = {...data}
    delete updatedData.docid
    return setDoc(doc(db,'drivers',docid),updatedData)
}
export const deleteDriver  = (docid)=> deleteDoc(doc(db,'drivers',docid))


//Party Queries
export  const addParty  =  (data)=> addDoc(collection(db,'parties'),data)
export  const updateParty  =  (docid,data)=> {
    const updatedData = {...data}
    delete updatedData.docid
    return setDoc(doc(db,'parties',docid),updatedData)
}
export  const addPartyTransaction  =  (data,partyId)=> addDoc(collection(db,'parties',partyId),data)
export  const getParties = ()=> getDocs(collection(db,'parties'))
export  const getPartyLedger = (partyId)=> getDocs(collection(db,'parties',partyId,'ledger'))
export const deleteParty  = (docid)=> deleteDoc(doc(db,'parties',docid))


//vehicle queries
export const getVehicles = ()=> getDocs(collection(db,'vehicles'))
export  const addVehicle  =  (data)=> addDoc(collection(db,'vehicles'),data)
export  const updateVehicle  =  (docid,data)=> {
    const updatedData = {...data}
    delete updatedData.docid
    return setDoc(doc(db,'vehicles',docid),updatedData)
}
export const deleteVehicle  = (docid)=> deleteDoc(doc(db,'vehicles',docid))